import Vue from "vue";
import axios from "axios";
import { toast } from "@/controllers/alert";
import Cookies from "js-cookie";
import { mainStore } from "./cart";
const user = localStorage.getItem("user") || null;
const token = Cookies.get("token") || null;
const isLogged = Cookies.get("isLoggedIn");
const locale = localStorage.getItem("locale") || "la";
// state
export const state = {
  token: token,
  user: user ? JSON.parse(user) : {},
  isLoggedIn: isLogged ? JSON.parse(isLogged) : false,
  store_type: null, // 'POS'" // RESTAURANT,
  locale: locale,
  tax_include: 0,
  tax: 10,
  locales: [
    {
      code: "en",
      name: "English",
      englishName: "English",
      flag: "/images/us.svg",
    },
    {
      code: "la",
      name: "ລາວ",
      englishName: "Lao",
      flag: "/images/la.svg",
    },
    {
      code: "th",
      name: "ไทย",
      englishName: "Thai",
      flag: "/images/th.svg",
    },
    {
      code: "ch",
      name: "中文",
      englishName: "Chinese",
      flag: "/images/ch.svg",
    },
  ],
};
// getters
export const getters = {
  locales: (state) => state.locales,
  isLoggedIn: (state) => state.isLoggedIn,
  user: (state) => state.user,
  token: (state) => state.token,
  store_type: (state) => state.user?.stores?.store_type_code ?? null,
  tax_include: (state) => state.user?.stores?.tax_include ?? 0,
  tax: () => {
    const rate = Number(process.env.VUE_APP_TAX_RATE) || 10;
    return `(${rate}%)`;
  },
  tax_rate: () => Number(process.env.VUE_APP_TAX_RATE) || 10,
};

// mutations
export const mutations = {
  SET_TOKEN(state, payload) {
    state.isLoggedIn = true;
    state.token = payload;
  },
  LOGOUT(state) {
    state.token = "";
    state.user = {};
    state.isLoggedIn = false;
  },
  SET_USER(state, payload) {
    state.user = payload;
    localStorage.setItem("user", JSON.stringify(payload));
  },
};

// actions
export const actions = {
  async logout({ commit }, props) {
    try {
      // Clear cart before logging out (purely local, never trigger products_paginate)
      try {
        const cartStore = mainStore();
        if (cartStore) {
          if (typeof cartStore.clearCart === "function") {
            cartStore.clearCart();
          } else {
            cartStore.cart = [];
            cartStore.buffet_plan_lines = [];
            cartStore.sub_total = 0;
            cartStore.total_discount = 0;
            cartStore.total_price = 0;
            cartStore.received = 0;
            cartStore.updateCart();
          }
        }
      } catch (cartError) {
        console.warn("Failed to clear cart during logout:", cartError);
      }

      const http = (props && props.$http) || Vue.prototype.$http;
      if (http && typeof http.post === "function") {
        try {
          await http.post("logout");
        } catch (apiError) {
          console.warn("API logout request failed:", apiError);
        }
      }

      Cookies.remove("token");
      Cookies.remove("isLoggedIn");
      Cookies.remove("email");
      localStorage.removeItem("expired_at");
      localStorage.removeItem("user");
      localStorage.removeItem("selectedItem");
      // Clear cart-related localStorage items
      localStorage.removeItem("cart");
      localStorage.removeItem("sub_total");
      localStorage.removeItem("total_discount");
      localStorage.removeItem("total_price");
      localStorage.removeItem("received");
      localStorage.removeItem("buffet_plan_lines");
      if (http && http.defaults?.headers?.common) {
        delete http.defaults.headers.common["Authorization"];
      }
      await commit("LOGOUT");
      if (props && typeof toast === "function") {
        try {
          await toast(props, "logout_successfully");
        } catch (toastError) {
          console.warn("Logout toast failed:", toastError);
        }
      }
      window.location.href = "/";
    } catch (e) {
      console.log(e);
      window.location.href = "/";
    }
  },
  async clearUser({ commit }) {
    try {
      // Clear cart before clearing user
      try {
        const cartStore = mainStore();
        if (cartStore) {
          if (typeof cartStore.clearCart === "function") {
            cartStore.clearCart();
          } else {
            cartStore.cart = [];
            cartStore.buffet_plan_lines = [];
            cartStore.sub_total = 0;
            cartStore.total_discount = 0;
            cartStore.total_price = 0;
            cartStore.received = 0;
            cartStore.updateCart();
          }
        }
      } catch (cartError) {
        console.warn("Failed to clear cart during clearUser:", cartError);
      }

      const self = Vue.prototype;
      await commit("LOGOUT");
      Cookies.remove("token");
      Cookies.remove("isLoggedIn");
      localStorage.removeItem("user");
      localStorage.removeItem("selectedItem");
      // Clear cart-related localStorage items
      localStorage.removeItem("cart");
      localStorage.removeItem("sub_total");
      localStorage.removeItem("total_discount");
      localStorage.removeItem("total_price");
      localStorage.removeItem("received");
      localStorage.removeItem("buffet_plan_lines");
      if (self.$http && self.$http.defaults?.headers?.common) {
        delete self.$http.defaults.headers.common["Authorization"];
      }
      try {
        await self.$http.post("logout");
      } catch (logoutError) {
        console.warn("clearUser logout call failed:", logoutError);
      }
      window.location.href = "/";
    } catch (e) {
      console.log(e);
      window.location.href = "/";
    }
  },
  async setDevice(context, token) {
    try {
      const self = Vue.prototype;
      await self.$http.post("/set_device_token", {
        device_token: token,
      });
    } catch (e) {
      console.log(e);
    }
  },
  async removeAuth({ commit }) {
    try {
      // Clear cart before removing auth
      try {
        const cartStore = mainStore();
        if (cartStore) {
          if (typeof cartStore.clearCart === "function") {
            cartStore.clearCart();
          } else {
            cartStore.cart = [];
            cartStore.buffet_plan_lines = [];
            cartStore.sub_total = 0;
            cartStore.total_discount = 0;
            cartStore.total_price = 0;
            cartStore.received = 0;
            cartStore.updateCart();
          }
        }
      } catch (cartError) {
        console.warn("Failed to clear cart during removeAuth:", cartError);
      }

      await commit("LOGOUT");
      Cookies.remove("token");
      Cookies.remove("isLoggedIn");
      localStorage.removeItem("user");
      localStorage.removeItem("selectedItem");
      // Clear cart-related localStorage items
      localStorage.removeItem("cart");
      localStorage.removeItem("sub_total");
      localStorage.removeItem("total_discount");
      localStorage.removeItem("total_price");
      localStorage.removeItem("received");
      localStorage.removeItem("buffet_plan_lines");
      delete axios.defaults.headers.common["Authorization"];
    } catch (e) {
      console.log(e);
    }
  },
};
